<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0592 6.86256V17.0591H2.9409V6.86256M8.43137 9.99997H11.5688M1.37219 2.9408H18.628V6.86256H1.37219V2.9408Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
